import React, { useEffect, useState } from "react";
import ContentLayout from "../../../../../partials/content/ContentLayout";
import ListLayout from "../../../../../partials/content/ListLayout";
import { getOutgoingPaymentDetail } from "../../../../../services/finance/outgoingPayment";
import OutgoingPaymentBasicInfo from "./outgoingPaymentBasicInfo";
import Notes from "../../../common/notes";
import Attachments from "../../../common/attachments";
import { PageSubHeader } from "../../../../../../provider/PageDataProvider";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
function OutgoingPaymentDetail({ match, history }) {
  const { reload } = useGlobalData();
  const paymentID = match.params.paymentID;
  const [payment, setPayment] = useState({
    ID: 0,
    vendor: {
      vendorName: "",
    },
    vendBankAccountDesc: "",
  });
  const [component, setComponent] = useState(null);
  const [headerTitle, setHeaderTitle] = useState("Basic Info");
  const [listMenu, setListMenu] = useState([
    {
      key: "basicInfo",
      label: "Basic Info",
      icon: "fas fa-th-large",
    },
    {
      key: "attachments",
      label: "Attachments",
      icon: "fas fa-paperclip",
    },
    {
      key: "notes",
      label: "Notes",
      icon: "fas fa-sticky-note",
    },
  ]);

  const defaultSelected = "basicInfo";

  useEffect(() => {
    getOutgoingPaymentData(paymentID);
  }, [paymentID, reload]);
  return (
    <React.Fragment>
      <PageSubHeader
        title={headerTitle ? headerTitle : "Basic Info"}
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/finance/payments/AP",
            title: "Payments",
            active: false,
          },
          {
            page: "/finance/outgoing-payment-detail/" + paymentID,
            title: "A/P Payment ID " + payment.outgoingPaymentCode,
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/finance/payments/AP");
            },
          },
        ]}
      />
      <ContentLayout>
        <ListLayout
          component={component}
          listMenu={listMenu}
          onSelectItem={(key) => {
            let selectedComponent;
            switch (key) {
              case "basicInfo":
                selectedComponent = (
                  <OutgoingPaymentBasicInfo payment={payment} />
                );
                setHeaderTitle("Basic Info");
                break;
              case "attachments":
                selectedComponent = (
                  <Attachments docType="PAYM" docID={payment.ID} />
                );
                setHeaderTitle("Attachments");
                break;
              case "notes":
                selectedComponent = <Notes docType="PAYM" docID={payment.ID} />;
                setHeaderTitle("Notes");
                break;
              default:
                selectedComponent = (
                  <OutgoingPaymentBasicInfo payment={payment} />
                );
                setHeaderTitle("Basic Info");
                break;
            }
            setComponent(selectedComponent);
          }}
          defaultSelected={defaultSelected}
        />
      </ContentLayout>
    </React.Fragment>
  );

  async function getOutgoingPaymentData(paymentID) {
    const response = await getOutgoingPaymentDetail(paymentID);
    const { data } = response.data;
    const componentTmp = (
      <OutgoingPaymentBasicInfo payment={data.outgoingPayment} />
    );
    setPayment(data.outgoingPayment);
    setComponent(componentTmp);
  }
}

export default OutgoingPaymentDetail;
